<script setup lang="ts">
import {Head, router, useForm} from "@inertiajs/vue3";
import AuthLayout from "@/layouts/AuthLayout.vue";
import {route} from "ziggy-js";
import VFieldLabel from "@/components/forms/VFieldLabel.vue";

defineOptions({layout: AuthLayout})

const form = useForm({
    email: new URLSearchParams(window.location.search).get('email') || '',
})

const submit = () => {
    form.post(route('password.email'))
}

const login = () => {
    router.visit(route('login'))
}
</script>

<template>
    <Head title="Forgot Password ⋅ Capacity Framework Portal" />
    <v-card
        variant="flat"
        class="justify-center"
    >
        <v-form @submit.prevent="submit">
            <v-card-title class="text-center text-h4 text-pre-wrap">
                <p>
                    Forgot password?
                </p>
                <p class="text-h5 text-medium-emphasis">
                    Enter your email for instructions
                </p>
            </v-card-title>
            <v-card-text class="mt-3 px-3 pb-3">
                <v-field-label>
                    Email address
                </v-field-label>
                <v-text-field
                    v-model="form.email"
                    type="email"
                    name="email"
                    autocomplete="email"
                    class="mb-3"
                    :hide-details="!form.hasErrors"
                    :error-messages="form.errors.email"
                    autofocus
                />
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-btn
                    variant="flat"
                    type="submit"
                    :loading="form.processing"
                    block
                >
                    Send instructions
                </v-btn>
            </v-card-actions>
        </v-form>
        <p class="text-body-2 text-center mt-3">
            Already have an account? <span
                class="text-primary custom-link"
                @click="login"
            >
                Log in
            </span>
        </p>
    </v-card>
</template>

<style scoped>

</style>
